const automations = {
  pageName: 'Automatisierungen',
  btnCreate: 'Erstellen',
  btnUseTemplate: 'Vorlage verwenden',
  mainTabs: {
    titleAutomationsCenter: 'Automatisierungszentrum',
    titleAutomationsExisting: 'Vorhandene Automatisierungen',
  },
  deleteModal: {
    header: 'Automatisierungen löschen',
    body: 'Sie sind dabei, {{num}} Automatisierungen zu löschen.',
    success: 'Automatisierungen wurden erfolgreich gelöscht',
  },
  table: {
    header: {
      name: 'Name',
      nextRun: 'Nächster Lauf',
      lastRun: 'Letzter Lauf',
      createdAt: 'Erstellungsdatum',
      createdBy: 'Erstellt von',
      actionType: 'Aktionstyp',
      status: 'Status',
      profiles: 'Profil',
      suppliers: 'Anbieter',
      attributes: 'Eigenschaften',
      areas: 'Zones',
      run: 'Jetzt',
    },
    filters: {
      status: {
        title: 'Status',
        options: {
          on: 'An',
          off: 'Aus',
        },
      },
      profiles: {
        title: 'Profil',
      },
      suppliers: {
        title: 'Anbieter',
      },
      attributes: {
        title: 'Eigenschaften',
      },
      areas: {
        title: 'Zones',
      },
      actionType: {
        title: 'Aktionstyp',
        options: {
          routingProcess: 'Routing-Prozess',
          busRoute: 'Buslinie',
          driverAssignment: 'Fahrerzuweisung',
        },
      },
    },
    actions: {
      run: 'Jetzt ausführen',
      duplicate: {
        title: 'Duplikat',
      },
      delete: {
        title: 'Löschen',
      },
    },
    toasts: {
      delete: {
        success: 'Erfolgreich gelöscht!',
        error: 'Fehler aufgetreten! Zone konnte nicht gelöscht werden',
      },
      run: {
        success: 'Automatisierung in Warteschlange. Sie wird in Kürze ausgeführt',
        error: 'Fehler aufgetreten! Automatisierung konnte nicht ausgeführt werden',
      },
    },
  },
  wizard: {
    titleCreate: 'Erstellen',
    titleUpdate: 'Aktualisieren',
    trigger: {
      title: '1. Auslöser',
      subTitle: 'Ein Auslöser ist ein Ereignis, das Ihre Automatisierung startet',
      loadingText: 'Bitte warten Sie, bis die Parameter geladen sind.',
      selectTrigger: {
        label: 'Auslösen',
      },
      btnContinue: 'Weitermachen',
    },
    action: {
      title: '2. Aktion',
      subTitle: 'Eine Aktion ist ein Ereignis, das nach seinem Start ausgeführt wird',
      loadingText: 'Bitte warten Sie, bis die Parameter geladen sind.',
      selectAction: {
        label: 'Aktion',
      },
      btnContinue: 'Weitermachen',
    },
    information: {
      title: '3. Informationen',
      subTitle: 'Allgemeine Informationen zur Automatisierung',
      name: 'Automatisierungsname',
      description: 'Beschreibung',
      profile: 'Profil',
      supplier: 'Anbieter',
      attributes: 'Eigenschaften',
      areas: 'Zone',
      btnSubmit: 'Einreichen',
    },
  },
  automationsCenter: {
    tabs: {
      all: 'Alle',
      routingProcess: 'Routing-Prozess',
      busRoute: 'Buslinie',
      driverAssignment: 'Fahrerzuweisung',
    },
  },
  toasts: {
    error: 'Etwas ist schief gelaufen',
    successCreated: 'Erfolgreich erstellt',
    successUpdated: 'Erfolgreich aktualisiert',
  },
};

export default automations;
